<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_return_tab_month_item') }} </v-tab>
      <v-tab href="#tab-2">{{ $t('quotation_tab_second') }}</v-tab>
      <v-tab-item value="tab-1">
        <move-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          :repairCustomerId="repairCustomerId"
          @setAllMoveMonth="setAllMoveMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMoveMonthItem="setMoveMonthItem"
          @deleteMoveMonthItem="deleteMoveMonthItem"
        />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <new-discount-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :discountItemList="discountItemList"
          @setAllDiscount="setAllDiscount"
          @deleteDiscountItem="deleteDiscountItem"
          @setDiscountItem="setDiscountItem"
          @setDiscountItemIndex="setDiscountItemIndex"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import NewDiscountSetting from '@/components/Quotation/DiscountItem/NewDiscountSetting.vue'
import MoveMonthSetting from '@/components/Quotation/MonthItem/MoveMonthSetting.vue'
export default {
  components: { MoveMonthSetting, NewDiscountSetting },
  name: 'MoveCar',

  data: () => ({}),
  watch: {
    carQuantity (val) {
      if (this.monthItemList.length > 0) {
        this.monthItemList.forEach((element) => {
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
      }
    }
  },
  methods: {
    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    },

    setAllMoveMonth (temp) {
      this.$emit('setAllMoveMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMoveMonthItem (val) {
      this.$emit('setMoveMonthItem', val)
    },
    deleteMoveMonthItem () {
      this.$emit('deleteMoveMonthItem')
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType',
    'discountItemList',
    'repairCustomerId'
  ]
}
</script>
